/** Directors' Resolution — directorCount / signers 동기화 (Create / Edit 공통). */

export interface ResolutionSignerRow {
  name: string;
}

function trimName(raw: unknown): string {
  return raw === null || raw === undefined ? '' : String(raw).trim();
}

export function hasSavedResolutionSigners(signers: ResolutionSignerRow[]): boolean {
  return (signers || []).some((s) => trimName(s?.name));
}

/**
 * Edit: 저장된 directorCount 유지.
 * Create: entity director 수로 설정.
 */
export function resolveDirectorCountOnEntityLoad(input: {
  editMode: boolean;
  savedDirectorCount: number;
  entityDirectorCount: number;
}): number {
  const entityCount = Math.max(1, input.entityDirectorCount || 1);
  if (!input.editMode) return entityCount;
  const saved = Number(input.savedDirectorCount);
  if (Number.isFinite(saved) && saved >= 1) return Math.floor(saved);
  return entityCount;
}

/** loadEntityData 직후 자동 signer 동기화 여부 */
export function shouldSyncAutoSignersOnEntityLoad(input: {
  editMode: boolean;
  specifySigners: boolean;
  signers: ResolutionSignerRow[];
}): boolean {
  if (input.specifySigners) return false;
  if (!input.editMode) return true;
  return !hasSavedResolutionSigners(input.signers);
}

/** directorCount 변경 watcher — Edit + 저장된 signer 가 있으면 auto-sync skip */
export function shouldSyncAutoSignersOnDirectorCountChange(input: {
  editMode: boolean;
  specifySigners: boolean;
  signers: ResolutionSignerRow[];
}): boolean {
  if (input.specifySigners) return false;
  if (!input.editMode) return true;
  return !hasSavedResolutionSigners(input.signers);
}
